import _regeneratorRuntime from "D:\\projects\\suseval\\node_modules\\@babel\\runtime-corejs2/regenerator";
import "core-js/modules/es6.regexp.replace";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:\\projects\\suseval\\node_modules\\@babel\\runtime-corejs2/helpers/asyncToGenerator";

/**
 * THIS FILE IS GENERATED AUTOMATICALLY.
 * DO NOT EDIT.
 *
 * You are probably looking on adding startup/initialization code.
 * Use "quasar new boot <name>" and add it there.
 * One boot file per concern. Then reference the file(s) in quasar.conf.js > boot:
 * boot: ['file', ...] // do not add ".js" extension to it.
 *
 * Boot files are your "main.js"
 **/
import '@quasar/extras/fontawesome-v5/fontawesome-v5.css';
import '@quasar/extras/roboto-font-latin-ext/roboto-font-latin-ext.css';
import '@quasar/extras/material-icons/material-icons.css';
import '@quasar/extras/animate/bounceIn.css';
import '@quasar/extras/animate/bounceOut.css';
import '@quasar/extras/animate/fadeInDown.css';
import '@quasar/extras/animate/fadeOutUp.css'; // We load Quasar stylesheet file

import 'quasar/dist/quasar.sass';
import 'src/css/app.scss';
import '@quasar/quasar-ui-qmediaplayer/src/index.sass';
import Vue from 'vue';
import createApp from "./app.js";
import 'app/src-pwa/register-service-worker.js';
import qboot_Boot_meteor from 'boot/_meteor';
import qboot_Booti18n from 'boot/i18n';
import qboot_Bootvuelidate from 'boot/vuelidate';
import qboot_Bootellipsis from 'boot/ellipsis';
import qboot_Bootrouter from 'boot/router';
import qboot_Bootvuetour from 'boot/vue-tour';
import qboot_Bootmeteor from 'boot/meteor';
import qboot_Bootvuesocialsharing from 'boot/vue-social-sharing';
import qboot_Bootmoment from 'boot/moment';
import qboot_Bootvuevirtualscroller from 'boot/vue-virtual-scroller';
import qboot_Bootopus from 'boot/opus';
import qboot_Bootgstore from 'boot/gstore';
import qboot_Bootleaflet from 'boot/leaflet';
import qboot_Bootvuehtml2pdf from 'boot/vue-html2pdf';
import qboot_Bootsentryio from 'boot/sentryio';
import qboot_Bootcloudinary from 'boot/cloudinary';
import qboot_Quasarquasarappextensionqmediaplayersrcbootregisterjs from '@quasar/quasar-app-extension-qmediaplayer/src/boot/register.js'; // Needed only for iOS PWAs

if (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream && window.navigator.standalone) {
  import(
  /* webpackChunkName: "fastclick"  */
  '@quasar/fastclick');
}

function start() {
  return _start.apply(this, arguments);
}

function _start() {
  _start = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee() {
    var _ref, app, store, router, routeUnchanged, redirect, urlPath, bootFiles, i;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return createApp();

          case 2:
            _ref = _context.sent;
            app = _ref.app;
            store = _ref.store;
            router = _ref.router;
            routeUnchanged = true;

            redirect = function redirect(url) {
              routeUnchanged = false;
              window.location.href = url;
            };

            urlPath = window.location.href.replace(window.location.origin, '');
            bootFiles = [qboot_Boot_meteor, qboot_Booti18n, qboot_Bootvuelidate, qboot_Bootellipsis, qboot_Bootrouter, qboot_Bootvuetour, qboot_Bootmeteor, qboot_Bootvuesocialsharing, qboot_Bootmoment, qboot_Bootvuevirtualscroller, qboot_Bootopus, qboot_Bootgstore, qboot_Bootleaflet, qboot_Bootvuehtml2pdf, qboot_Bootsentryio, qboot_Bootcloudinary, qboot_Quasarquasarappextensionqmediaplayersrcbootregisterjs];
            i = 0;

          case 11:
            if (!(routeUnchanged === true && i < bootFiles.length)) {
              _context.next = 29;
              break;
            }

            if (!(typeof bootFiles[i] !== 'function')) {
              _context.next = 14;
              break;
            }

            return _context.abrupt("continue", 26);

          case 14:
            _context.prev = 14;
            _context.next = 17;
            return bootFiles[i]({
              app: app,
              router: router,
              store: store,
              Vue: Vue,
              ssrContext: null,
              redirect: redirect,
              urlPath: urlPath
            });

          case 17:
            _context.next = 26;
            break;

          case 19:
            _context.prev = 19;
            _context.t0 = _context["catch"](14);

            if (!(_context.t0 && _context.t0.url)) {
              _context.next = 24;
              break;
            }

            window.location.href = _context.t0.url;
            return _context.abrupt("return");

          case 24:
            console.error('[Quasar] boot error:', _context.t0);
            return _context.abrupt("return");

          case 26:
            i++;
            _context.next = 11;
            break;

          case 29:
            if (!(routeUnchanged === false)) {
              _context.next = 31;
              break;
            }

            return _context.abrupt("return");

          case 31:
            new Vue(app);

          case 32:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[14, 19]]);
  }));
  return _start.apply(this, arguments);
}

start();